<template>
  <div class="wrapper_results" id="reco-app-results">
    <div class="header_reco">Nos recommandations</div>
    <div class="bd__results">
      <Spinner v-if="loading" />
      <div v-if="results">
        <div v-if="cpt_new_res == 1">
          {{ /* Si la requete "normale" ne donne rien, on en relance 1 avec moins de paramètres  et ce texte est affiché */ }}
          <p class="texte_res_new">
            Nous n'avons pas trouvé d'album correspondant à votre recherche !
            <br />
            Voici malgré tout une proposition de lecture <br />qui pourrait vous
            intéresser :
          </p>
        </div>
        <div v-html="results"></div>
      </div>
      <div v-else-if="!loading && cpt_new_res == 1">
        <p>
          Nous n'avons pas trouvé d'album correspondant à votre recherche !
        </p>
      </div>
    </div>
    <Footer v-if="this.history.length > 0" />
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import apiManager from "../services/ApiManager";
import Footer from "../components/Footer";
import Spinner from "../components/Spinner";

export default {
  name: "Results",
  data() {
    return {
      results: null
    };
  },

  components: {
    Footer,
    Spinner
  },
  computed: {
    // récupération des éléments du store
    ...mapState([
      "age",
      "genre",
      "history",
      "freqLecture",
      "typeLecture",
      "oneShot",
      "envieNC",
      "offSet",
      "range",
      "changeGenre",
      "current_question",
      "loading",
      "componentKey",
      "scenario",
      "classic",
      "cpt_new_res"
    ])
  },
  methods: {
    ...mapMutations([
      "SET_LOADING",
      "SET_FREQLECTURE",
      "SET_TYPELECTURE",
      "SET_COMPONENTKEY",
      "SET_ONESHOT",
      "SET_CPTNEWRES",
      "SET_CLASSIC"
    ])
  },
  async created() {
    //envoiRequete();
    // on ajoute dans les params les éléments du store
    const params = {
      age: this.age,
      genre: this.genre,
      freqLecture: this.freqLecture,
      typeLecture: this.typeLecture,
      oneShot: this.oneShot,
      envieNC: this.envieNC,
      offset: this.offSet,
      range: this.range,
      scenario: this.scenario,
      classic: this.cpt_new_res === 1
    };
    this.SET_LOADING(true);

    //envoie des resultats vers le controller avec les paramètres du store
    const response = await apiManager.fetchResults(params);
    if (response.error) {
      this.results = "<p>Désolé une erreur est survenue.</p>";
    } else {
      this.results = response.output;
      this.$nextTick(() => {
        if (this.results) {
          setTimeout(() => {
            Drupal.attachBehaviors(
              document.getElementById("appli_reco"),
              drupalSettings
            );
          });

          var els = document.querySelectorAll(".card-album a");
          for (var i = 0; i < els.length; i++) {
            els[i].setAttribute("target", "_blank");
          }
        }
        /* Si on a pas de resultat pour la première requete,
        on en relance une sans frequence, type et one shot,
        1 fois pour éviter boucle infinies */
        if (!this.results && this.cpt_new_res < 1) {
          this.SET_CPTNEWRES(1);
          this.SET_FREQLECTURE(null);
          this.SET_TYPELECTURE(null);
          this.SET_COMPONENTKEY();
        }
        this.SET_LOADING(false);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.header_reco {
  height: 72px;
  line-height: 72px;
  color: white;
  padding-left: 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.7);
  text-align: left;
  font-size: 18px;
  font-weight: bold;
}

p {
  padding: 20px;
  color: white;
}

.bd__results {
  /deep/ {
    ul {
      list-style-type: none;
    }

    .carousel {
      padding-left: 20px;
    }

    .slider--list-bd .gallery-cell {
      width: 200px;
    }

    .card-album {
      width: 196px;
      padding: 28px 20px 0 0;
      text-align: left;

      a,
      p,
      span {
        color: white;
      }
    }

    .card-album__title {
      font-size: 15px;
      line-height: 17px;
    }

    .icon-ic_reading {
      color: white;
    }

    .texteMangaComics {
      color: #fff;
      padding: 30px 20px 0 20px;
      line-height: 18px;
      font-size: 16px;
    }

    // banniere manga et comics
    .bannerMangaComics {
      margin-top: 30px;
      margin-bottom: 30px;
      max-height: 140px;
      max-width: 330px;
    }
    .texte_res_new {
      padding: 15px 20px 0px 20px;
      line-height: 18px;
      font-size: 16px;
    }
  }
}
</style>
